import VerticalNavigation from './VerticalNavigation';

class VerticalNavigationAO extends VerticalNavigation {
  constructor(props) {
    super(props);  

    this.state = {
        redraw:false
    }
  }

  onClick(value, index){
    this.changeItem(value, index);

    this.props.data.AOModuleCallback(value, index);
  }

 
}

export default VerticalNavigationAO;